const se = {
  kicker: "Báikkálaš fitnodagaide ja viesuoamasteddjiide",
  title: "Šatta guossoheaddjin Trollfossjaktenis.",
  lead: "Guossoheaddji lea báikkálaš fitnodat dahje viesuoamasteaddji bálgá guoras Loabága ja Årsteina (Rivttága) gaskkas — kafea, dállu, hytta, B&B, sávdni dahje gávpi. Guossoheaddjit váldet vuostá stálubivddu guossiid ja dohkkehit Stálukruvnnuid (TK), speallama iežas ruđaid, máksun.",
  badges: ["Nuvttá", "Sullii 2 minuhta", "Kártii dakkaviđe"],
  waysKicker: "Guokte vuogi searvat",
  waysTitle: "Vállje ovtta — dahje goappašagaid.",
  ways: [
    { title: "Guossohanbáiki", tag: "Dohkkeha Stálukruvnnuid", body: "Don oidnot kártas, ja guossit sáhttet máksit dutnje TK:iiguin iežaset seahkas." },
    { title: "Vuoiŋŋastanbáiki", tag: "Dušše listu", body: "Kártanálla mii čájeha du bálvalusaid, nugo biilla dahje sykkela luđen, dušša, borramušmenu, B&B, leairra, wifi, parkeren, hivsset ja kaffe. Nuvttá oidnosis — ruđat eai gieđahallojuvvo." },
  ],
  both: "Sáhtát dahkat goappašagaid.",
  joinKicker: "Movt šaddat guossoheaddjin",
  joinTitle: "Sullii 2 minuhta, ja nuvttá.",
  steps: ["Viečča áppa ja čálit sisa.", "Mana Profiila → Šatta guossoheaddjin → Registrere guossoheaddjin.", "Deavdde dieđuid (geahča listtu).", "Gearggus — don leat kártas dakkaviđe."],
  formTitle: "Dán don deavddát",
  fields: [["Fitnodatnamma", "bákkolaš"], ["Čujuhus", "bákkolaš"], ["Telefovdna", "eaktodáhtolaš"], ["Maid fálat", "omd. «kaffe, vafelat, sávdni»"]],
  amenitiesTitle: "Du fálaldagat",
  noWait: "Ii dohkkehanáigi ja ii dieđihanmáksu.",
  pitTitle: "Lasit vuoiŋŋastanbáikki",
  pitBody: "Mana Profiila → Fála vuoiŋŋastanbáikki → Registrere vuoiŋŋastanbáikki, ja čális nama, čujuhusa, telefovnna, saji kártas ja fálaldagaid.",
  tkKicker: "Movt Stálukruvnnut doibmet",
  tkTitle: "1 TK = 1 kruvdno.",
  tkEarnTitle: "Guossit ožžot TK:id go",
  tkEarn: ["bovdejit ustibiid — sii ožžot 50 % ruovttoluotta ustiba vuosttaš pássaoastimis", "olahit Arrow Hunter-dási bonusiid: +10 / +25 / +100 TK", "jorahit vuoitojuvlla"],
  tkRule: "TK:id sáhttá geavahit dušše registrerejuvvon guossoheddjiid luhtte. Guossit eai sáhte váldit daid ruđan.",
  payKicker: "Váldit vuostá máksima",
  payTitle: "Guossoheaddji dashboard rehkenastá dutnje.",
  paySteps: ["Guossi rahpá Profiila → Čájet mu máksin-QR.", "Don skánnet dan dahje čálát seahkakoda (TK-XXXXXX).", "Čális supmi kruvnnuin ja maid sii osttiiga, omd. «kaffe ja vafelat».", "Áppa geassá nu ollu go vejolaš TK-saldos ja čájeha loahpa maid váldát ruđain dahje kortain."],
  exampleTitle: "Ovdamearka",
  example: { note: "85 kr oastin, 60 TK seahkas", total: "Oastin", tk: "Máksojuvvon TK:in", rest: "Váldojuvvo ruđain dahje kortain" },
  dashboard: "Du dashboard čájeha juohke vuovdima, ja otná ja oktiibuot TK maid leat ožžon.",
  ctaTitle: "Gearggus váldit vuostá stáluguossiid?",
  ctaBody: "Viečča áppa, čálit sisa ja registrere guossoheaddjin — dat váldá sullii guokte minuhta.",
  cta: "Viečča áppa",
  ctaPartner: "Háliidatgo maiddái iežat stáluid? Geahča guoibmepáhkaid",
  ctaHost: "Registrere guossoheaddjin",
  webNote: "Háliidatgo baicca geavahit neahttasiiddu? Registrere dáppe — merke du báikki kártii, muital maid fálat ja merke du fálaldagaid.",
};

export default se;
